import { db } from '../firebase';
import firebase from 'firebase/app';

const PAGE_SIZE = 50;

export async function getAdhkar({ page = 1, pageSize = 20 } = {}) {
  const snapshot = await db.collection('adhkar').get();
  let items = snapshot.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter(item => !item.isDeleted);

  items.sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0));

  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const validPage = Math.max(1, Math.min(page, totalPages));
  const startIndex = (validPage - 1) * pageSize;
  const paginatedItems = items.slice(startIndex, startIndex + pageSize);

  return {
    items: paginatedItems,
    total,
    totalPages,
    page: validPage,
    pageSize,
    hasMore: startIndex + pageSize < total
  };
}

export async function getPrevAdhkar() {
  return { items: [] };
}

export async function getAdhkarById(id) {
  const doc = await db.collection('adhkar').doc(id).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
}

export async function createAdhkar(data) {
  const maxOrder = await db.collection('adhkar').orderBy('orderIndex', 'desc').limit(1).get();
  const orderIndex = maxOrder.empty ? 0 : (maxOrder.docs[0].data().orderIndex || 0) + 1;
  return db.collection('adhkar').add({
    name: data.name || { en: '', bn: '' },
    arabic: data.arabic || '',
    target: data.target || 33,
    orderIndex,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function updateAdhkar(id, data) {
  return db.collection('adhkar').doc(id).update({
    ...data,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function deleteAdhkar(id) {
  return db.collection('adhkar').doc(id).update({
    isDeleted: true,
    deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  });
}

export async function reorderAdhkar(id, newOrderIndex) {
  return db.collection('adhkar').doc(id).update({ orderIndex: newOrderIndex });
}

export async function getAllAdhkar() {
  const snapshot = await db.collection('adhkar').orderBy('orderIndex').get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getTotalAdhkar() {
  const snapshot = await db.collection('adhkar').get();
  return snapshot.size;
}
